import { ContextualIcon, Tag, TagColor } from '@varo/graphql-schema-types';
import { IconKeyType } from 'shared/components/vxl/icon/Icon/Icon';
import { Maybe } from 'shared/utils/types';

import { TagProps, TagType } from './Tag';

const tagColorToTagTypeMap = {
  [TagColor.UndefinedTagtype]: TagType.INFO,
  [TagColor.Info]: TagType.INFO,
  [TagColor.Positive]: TagType.SUCCESS,
  [TagColor.Warning]: TagType.WARNING,
  [TagColor.Negative]: TagType.ERROR,
  [TagColor.Emphasized]: TagType.INFO_EMPHASIZED,
  [TagColor.Reverse]: TagType.INFO_REVERSE,
  [TagColor.Highlight]: TagType.HIGHLIGHT,
  [TagColor.InfoReverse]: TagType.INFO_REVERSE,
};

export const propsFromTag = (gqlTag: Maybe<Tag>): Maybe<TagProps> => {
  if (!gqlTag) {
    return null;
  }

  return {
    type: toTagType(gqlTag.tagColor),
    text: gqlTag.text,
    iconKey: toTagIconKey(gqlTag.icon),
  };
};

export const toTagType = (tagColor: TagColor): TagType => {
  return tagColorToTagTypeMap[tagColor];
};

export const toTagIconKey = (
  tagIcon: Maybe<ContextualIcon>,
): Maybe<IconKeyType> => {
  if (!tagIcon) {
    return null;
  }

  switch (tagIcon) {
    case ContextualIcon.Bolt:
      return 'BOLT';
    case ContextualIcon.ListCheckmarkMedium:
      return 'LIST_CHECK_MARK';
    case ContextualIcon.ListCheckmark:
      return 'LIST_CHECK_MARK';
    case ContextualIcon.ClockSmall:
      return 'CLOCK';
    case ContextualIcon.SparkleFilled:
      return 'SPARKLE_FILLED';
    default:
      return undefined;
  }
};
